import axios from "axios";
import _ from "lodash";
import { store } from "./storeInitializer";
import * as sessionActions from "./modules/session";
import timezones from "./timezones";
export const panelDefaultTitle = "Panel";
import t from "Utils/translation";

// configure axios
// Add a response interceptor
let request = axios.create({
  baseURL: BASE_URL, // is a constant of webpack
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

request.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  (error) => {
    if (error.response === undefined && document.location.pathname !== "/manteinance") {
      document.location.replace("/manteinance");
    }

    if (error.response.status === 401) {
      store.dispatch(sessionActions.unsetSession());
    }
    return Promise.reject(error);
  }
);

export default request;

export const supportEmailAddress = "support@qboxmail.com";
// return an array of object like {msg: 'email is invalid'}
export function formatServerErrors(errors) {
  return _.map(errors, (error) => ({
    msg: `${error.field} ${error.description}`,
    field: error.field,
  }));
}

//
export function convertServerErrors(errors) {
  let formErros = {};
  _.each(errors, (error) => {
    formErros[error.field] = `${error.field.replace(/_/g, " ")} ${error.description}`;
  });

  return formErros;
}
// return an array of object like {msg: 'email is invalid'}
export function formatClientErrors(errors) {
  let errorStrings = _.map(errors, (error, field) => _.map(error, (msg) => ({ msg: field + ": " + msg, field })));
  return _.flattenDeep(errorStrings);
}

export function getCookie(name) {
  let re = new RegExp(`${name}=([^;]+)`);
  let value = re.exec(document.cookie);
  return value != null ? unescape(value[1]) : undefined;
}

export function createCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

export function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

export function timer(name) {
  const start = new Date();
  return {
    stop: function () {
      const end = new Date();
      const time = end.getTime() - start.getTime();
      console.log("Timer:", name, "finished in", time, "ms");
    },
  };
}

export const getPanelLangs = () => [
  { value: "it", label: t("select.value.italian") },
  { value: "en", label: t("select.value.english") },
  { value: "es", label: t("select.value.spanish") },
];

export const getWebmailLangs = () => [
  { value: "it", label: t("select.value.italian") },
  { value: "en", label: t("select.value.english") },
  { value: "nl", label: t("select.value.nl") },
  { value: "sv", label: t("select.value.sv") },
  { value: "es", label: t("select.value.es") },
  { value: "pt", label: t("select.value.pt") },
  { value: "de", label: t("select.value.de") },
  { value: "gr", label: t("select.value.gr") },
  { value: "fr", label: t("select.value.fr") },
];

export const webmailTimeFormats = [
  { value: "12h", label: "12h" },
  { value: "24h", label: "24h" },
];

export const webmailDateFormats = [
  { value: "YYYY/MM/DD", label: "YYYY/MM/DD" },
  { value: "DD/MM/YYYY", label: "DD/MM/YYYY" },
  { value: "MM/DD/YYYY", label: "MM/DD/YYYY" },
  { value: "DD MMM YYYY", label: "DD MMM YYYY" },
  { value: "MMM DD YYYY", label: "MMM DD YYYY" },
  { value: "DD.MM.YYYY", label: "DD.MM.YYYY" },
];

export const quotas = [
  { value: 52428800, label: "50 MB" },
  { value: 1073741824, label: "1 GB" },
  { value: 2147483648, label: "2 GB" },
  { value: 3221225472, label: "3 GB" },
  { value: 4294967296, label: "4 GB" },
  { value: 5368709120, label: "5 GB" },
  { value: 6442450944, label: "6 GB" },
  { value: 7516192768, label: "7 GB" },
  { value: 8589934592, label: "8 GB" },
  { value: 17179869184, label: "16 GB" },
  { value: 26843545600, label: "25 GB" },
  { value: 53687091200, label: "50 GB" },
  { value: 107374182400, label: "100 GB" },
];

export const quotasWithout50MB = quotas.filter((q) => q.value !== 52428800);

export const humanQuotas = {
  "1GB": 1073741824,
  "2GB": 2147483648,
  "3GB": 3221225472,
  "4GB": 4294967296,
  "5GB": 5368709120,
  "6GB": 6442450944,
  "7GB": 7516192768,
  "8GB": 8589934592,
  "16GB": 17179869184,
  "25GB": 26843545600,
  "50GB": 53687091200,
  "100GB": 107374182400,
};

export const tzs = timezones;

export const allCountries = [
  { value: "AF", label: "Afghanistan", ita_label: "Afghanistan" },
  ,
  { value: "AL", label: "Albania", ita_label: "Albania" },
  { value: "DZ", label: "Algeria", ita_label: "Algeria" },
  { value: "AS", label: "American Samoa", ita_label: "Samoa Americane" },
  { value: "AD", label: "Andorra", ita_label: "Andorra" },
  { value: "AO", label: "Angola", ita_label: "Angola" },
  { value: "AI", label: "Anguilla", ita_label: "Anguilla" },
  { value: "AQ", label: "Antarctica", ita_label: "Antartide" },
  { value: "AG", label: "Antigua and Barbuda", ita_label: "Antigua e Barbuda" },
  { value: "AR", label: "Argentina", ita_label: "Argentina" },
  { value: "AM", label: "Armenia", ita_label: "Armenia" },
  { value: "AW", label: "Aruba", ita_label: "Aruba" },
  { value: "AU", label: "Australia", ita_label: "Australia" },
  { value: "AT", label: "Austria", ita_label: "Austria" },
  { value: "AZ", label: "Azerbaijan", ita_label: "Azerbaigian" },
  { value: "BS", label: "Bahamas", ita_label: "Bahamas" },
  { value: "BH", label: "Bahrain", ita_label: "Bahrein" },
  { value: "BD", label: "Bangladesh", ita_label: "Bangladesh" },
  { value: "BB", label: "Barbados", ita_label: "Barbados" },
  { value: "BY", label: "Belarus", ita_label: "Bielorussia" },
  { value: "BE", label: "Belgium", ita_label: "Belgio" },
  { value: "BZ", label: "Belize", ita_label: "Belize" },
  { value: "BJ", label: "Benin", ita_label: "Benin" },
  { value: "BM", label: "Bermuda", ita_label: "Bermuda" },
  { value: "BT", label: "Bhutan", ita_label: "Bhutan" },
  { value: "BO", label: "Bolivia", ita_label: "Bolivia" },
  { value: "BA", label: "Bosnia and Herzegovina", ita_label: "Bosnia ed Erzegovina" },
  { value: "BW", label: "Botswana", ita_label: "Botswana" },
  { value: "BV", label: "Bouvet Island", ita_label: "Isola Bouvet" },
  { value: "BR", label: "Brazil", ita_label: "Brasile" },
  { value: "IO", label: "British Indian Ocean Territory", ita_label: "Territorio Britannico dell'Oceano Indiano" },
  { value: "VG", label: "British Virgin Islands", ita_label: "Isole Vergini Britanniche" },
  { value: "BN", label: "Brunei", ita_label: "Brunei" },
  { value: "BG", label: "Bulgaria", ita_label: "Bulgaria" },
  { value: "BF", label: "Burkina Faso", ita_label: "Burkina Faso" },
  { value: "BI", label: "Burundi", ita_label: "Burundi" },
  { value: "KH", label: "Cambodia", ita_label: "Cambogia" },
  { value: "CM", label: "Cameroon", ita_label: "Camerun" },
  { value: "CA", label: "Canada", ita_label: "Canada" },
  { value: "CV", label: "Cape Verde", ita_label: "Capo Verde" },
  { value: "KY", label: "Cayman Islands", ita_label: "Isole Cayman" },
  { value: "CF", label: "Central African Republic", ita_label: "Repubblica Centrafricana" },
  { value: "TD", label: "Chad", ita_label: "Ciad" },
  { value: "CL", label: "Chile", ita_label: "Cile" },
  { value: "CN", label: "China", ita_label: "Cina" },
  { value: "CX", label: "Christmas Island", ita_label: "Isola di Natale" },
  { value: "CC", label: "Cocos [Keeling] Islands", ita_label: "Isole Cocos [Keeling]" },
  { value: "CO", label: "Colombia", ita_label: "Colombia" },
  { value: "KM", label: "Comoros", ita_label: "Comore" },
  { value: "CG", label: "Congo - Brazzaville", ita_label: "Congo - Brazzaville" },
  { value: "CD", label: "Congo - Kinshasa", ita_label: "Congo - Kinshasa" },
  { value: "CK", label: "Cook Islands", ita_label: "Isole Cook" },
  { value: "CR", label: "Costa Rica", ita_label: "Costa Rica" },
  { value: "HR", label: "Croatia", ita_label: "Croazia" },
  { value: "CU", label: "Cuba", ita_label: "Cuba" },
  { value: "CY", label: "Cyprus", ita_label: "Cipro" },
  { value: "CZ", label: "Czech Republic", ita_label: "Repubblica Ceca" },
  { value: "CI", label: "Côte d’Ivoire", ita_label: "Costa d'Avorio" },
  { value: "DK", label: "Denmark", ita_label: "Danimarca" },
  { value: "DJ", label: "Djibouti", ita_label: "Gibuti" },
  { value: "DM", label: "Dominica", ita_label: "Dominica" },
  { value: "DO", label: "Dominican Republic", ita_label: "Repubblica Dominicana" },
  { value: "EC", label: "Ecuador", ita_label: "Ecuador" },
  { value: "EG", label: "Egypt", ita_label: "Egitto" },
  { value: "SV", label: "El Salvador", ita_label: "El Salvador" },
  { value: "GQ", label: "Equatorial Guinea", ita_label: "Guinea Equatoriale" },
  { value: "ER", label: "Eritrea", ita_label: "Eritrea" },
  { value: "EE", label: "Estonia", ita_label: "Estonia" },
  { value: "ET", label: "Ethiopia", ita_label: "Etiopia" },
  { value: "FK", label: "Falkland Islands", ita_label: "Isole Falkland" },
  { value: "FO", label: "Faroe Islands", ita_label: "Isole Fær Øer" },
  { value: "FJ", label: "Fiji", ita_label: "Figi" },
  { value: "FI", label: "Finland", ita_label: "Finlandia" },
  { value: "FR", label: "France", ita_label: "Francia" },
  { value: "GF", label: "French Guiana", ita_label: "Guyana Francese" },
  { value: "PF", label: "French Polynesia", ita_label: "Polinesia Francese" },
  { value: "TF", label: "French Southern Territories", ita_label: "Territori Francesi del Sud" },
  { value: "GA", label: "Gabon", ita_label: "Gabon" },
  { value: "GM", label: "Gambia", ita_label: "Gambia" },
  { value: "GE", label: "Georgia", ita_label: "Georgia" },
  { value: "DE", label: "Germany", ita_label: "Germania" },
  { value: "GH", label: "Ghana", ita_label: "Ghana" },
  { value: "GI", label: "Gibraltar", ita_label: "Gibilterra" },
  { value: "GR", label: "Greece", ita_label: "Grecia" },
  { value: "GL", label: "Greenland", ita_label: "Groenlandia" },
  { value: "GD", label: "Grenada", ita_label: "Grenada" },
  { value: "GP", label: "Guadeloupe", ita_label: "Guadalupa" },
  { value: "GU", label: "Guam", ita_label: "Guam" },
  { value: "GT", label: "Guatemala", ita_label: "Guatemala" },
  { value: "GG", label: "Guernsey", ita_label: "Guernsey" },
  { value: "GN", label: "Guinea", ita_label: "Guinea" },
  { value: "GW", label: "Guinea-Bissau", ita_label: "Guinea-Bissau" },
  { value: "GY", label: "Guyana", ita_label: "Guyana" },
  { value: "HT", label: "Haiti", ita_label: "Haiti" },
  { value: "HM", label: "Heard Island and McDonald Islands", ita_label: "Isole Heard e McDonald" },
  { value: "HN", label: "Honduras", ita_label: "Honduras" },
  { value: "HK", label: "Hong Kong SAR China", ita_label: "Hong Kong" },
  { value: "HU", label: "Hungary", ita_label: "Ungheria" },
  { value: "IS", label: "Iceland", ita_label: "Islanda" },
  { value: "IN", label: "India", ita_label: "India" },
  { value: "ID", label: "Indonesia", ita_label: "Indonesia" },
  { value: "IR", label: "Iran", ita_label: "Iran" },
  { value: "IQ", label: "Iraq", ita_label: "Iraq" },
  { value: "IE", label: "Ireland", ita_label: "Irlanda" },
  { value: "IL", label: "Israel", ita_label: "Israele" },
  { value: "IT", label: "Italy", ita_label: "Italia" },
  { value: "JM", label: "Jamaica", ita_label: "Giamaica" },
  { value: "JP", label: "Japan", ita_label: "Giappone" },
  { value: "JE", label: "Jersey", ita_label: "Jersey" },
  { value: "JO", label: "Jordan", ita_label: "Giordania" },
  { value: "KZ", label: "Kazakhstan", ita_label: "Kazakistan" },
  { value: "KE", label: "Kenya", ita_label: "Kenya" },
  { value: "KI", label: "Kiribati", ita_label: "Kiribati" },
  { value: "KW", label: "Kuwait", ita_label: "Kuwait" },
  { value: "KG", label: "Kyrgyzstan", ita_label: "Kirghizistan" },
  { value: "LA", label: "Laos", ita_label: "Laos" },
  { value: "LV", label: "Latvia", ita_label: "Lettonia" },
  { value: "LB", label: "Lebanon", ita_label: "Libano" },
  { value: "LS", label: "Lesotho", ita_label: "Lesotho" },
  { value: "LR", label: "Liberia", ita_label: "Liberia" },
  { value: "LY", label: "Libya", ita_label: "Libia" },
  { value: "LI", label: "Liechtenstein", ita_label: "Liechtenstein" },
  { value: "LT", label: "Lithuania", ita_label: "Lituania" },
  { value: "LU", label: "Luxembourg", ita_label: "Lussemburgo" },
  { value: "MO", label: "Macau SAR China", ita_label: "Macao" },
  { value: "MK", label: "North Macedonia", ita_label: "Macedonia del nord" },
  { value: "MG", label: "Madagascar", ita_label: "Madagascar" },
  { value: "MW", label: "Malawi", ita_label: "Malawi" },
  { value: "MY", label: "Malaysia", ita_label: "Malesia" },
  { value: "MV", label: "Maldives", ita_label: "Maldive" },
  { value: "ML", label: "Mali", ita_label: "Mali" },
  { value: "MT", label: "Malta", ita_label: "Malta" },
  { value: "MH", label: "Marshall Islands", ita_label: "Isole Marshall" },
  { value: "MQ", label: "Martinique", ita_label: "Martinica" },
  { value: "MR", label: "Mauritania", ita_label: "Mauritania" },
  { value: "MU", label: "Mauritius", ita_label: "Mauritius" },
  { value: "YT", label: "Mayotte", ita_label: "Mayotte" },
  { value: "FX", label: "Metropolitan France", ita_label: "Francia Metropolitana" },
  { value: "MX", label: "Mexico", ita_label: "Messico" },
  { value: "FM", label: "Micronesia", ita_label: "Micronesia" },
  { value: "MD", label: "Moldova", ita_label: "Moldavia" },
  { value: "MC", label: "Monaco", ita_label: "Monaco" },
  { value: "MN", label: "Mongolia", ita_label: "Mongolia" },
  { value: "ME", label: "Montenegro", ita_label: "Montenegro" },
  { value: "MS", label: "Montserrat", ita_label: "Montserrat" },
  { value: "MA", label: "Morocco", ita_label: "Marocco" },
  { value: "MZ", label: "Mozambique", ita_label: "Mozambico" },
  { value: "MM", label: "Myanmar [Burma]", ita_label: "Myanmar [Birmania]" },
  { value: "NA", label: "Namibia", ita_label: "Namibia" },
  { value: "NR", label: "Nauru", ita_label: "Nauru" },
  { value: "NP", label: "Nepal", ita_label: "Nepal" },
  { value: "NL", label: "Netherlands", ita_label: "Paesi Bassi" },
  { value: "AN", label: "Netherlands Antilles", ita_label: "Antille Olandesi" },
  { value: "NT", label: "Neutral Zone", ita_label: "Zona Neutrale" },
  { value: "NC", label: "New Caledonia", ita_label: "Nuova Caledonia" },
  { value: "NZ", label: "New Zealand", ita_label: "Nuova Zelanda" },
  { value: "NI", label: "Nicaragua", ita_label: "Nicaragua" },
  { value: "NE", label: "Niger", ita_label: "Niger" },
  { value: "NG", label: "Nigeria", ita_label: "Nigeria" },
  { value: "NU", label: "Niue", ita_label: "Niue" },
  { value: "NF", label: "Norfolk Island", ita_label: "Isola Norfolk" },
  { value: "KP", label: "North Korea", ita_label: "Corea del Nord" },
  { value: "MP", label: "Northern Mariana Islands", ita_label: "Isole Marianne Settentrionali" },
  { value: "NO", label: "Norway", ita_label: "Norvegia" },
  { value: "OM", label: "Oman", ita_label: "Oman" },
  { value: "PK", label: "Pakistan", ita_label: "Pakistan" },
  { value: "PW", label: "Palau", ita_label: "Palau" },
  { value: "PS", label: "Palestinian Territories", ita_label: "Territori Palestinesi" },
  { value: "PA", label: "Panama", ita_label: "Panama" },
  { value: "PG", label: "Papua New Guinea", ita_label: "Papua Nuova Guinea" },
  { value: "PY", label: "Paraguay", ita_label: "Paraguay" },
  {
    value: "YD",
    label: "People's Democratic Republic of Yemen",
    ita_label: "Repubblica Democratica Popolare dello Yemen",
  },
  { value: "PE", label: "Peru", ita_label: "Perù" },
  { value: "PH", label: "Philippines", ita_label: "Filippine" },
  { value: "PN", label: "Pitcairn Islands", ita_label: "Isole Pitcairn" },
  { value: "PL", label: "Poland", ita_label: "Polonia" },
  { value: "PT", label: "Portugal", ita_label: "Portogallo" },
  { value: "PR", label: "Puerto Rico", ita_label: "Porto Rico" },
  { value: "QA", label: "Qatar", ita_label: "Qatar" },
  { value: "RO", label: "Romania", ita_label: "Romania" },
  { value: "RU", label: "Russia", ita_label: "Russia" },
  { value: "RW", label: "Rwanda", ita_label: "Ruanda" },
  { value: "RE", label: "Réunion", ita_label: "Réunion" },
  { value: "BL", label: "Saint Barthélemy", ita_label: "Saint-Barthélemy" },
  { value: "SH", label: "Saint Helena", ita_label: "Sant'Elena" },
  { value: "KN", label: "Saint Kitts and Nevis", ita_label: "Saint Kitts e Nevis" },
  { value: "LC", label: "Saint Lucia", ita_label: "Santa Lucia" },
  { value: "MF", label: "Saint Martin", ita_label: "Saint Martin" },
  { value: "PM", label: "Saint Pierre and Miquelon", ita_label: "Saint-Pierre e Miquelon" },
  { value: "VC", label: "Saint Vincent and the Grenadines", ita_label: "Saint Vincent e Grenadine" },
  { value: "WS", label: "Samoa", ita_label: "Samoa" },
  { value: "SM", label: "San Marino", ita_label: "San Marino" },
  { value: "SA", label: "Saudi Arabia", ita_label: "Arabia Saudita" },
  { value: "SN", label: "Senegal", ita_label: "Senegal" },
  { value: "RS", label: "Serbia", ita_label: "Serbia" },
  { value: "CS", label: "Serbia and Montenegro", ita_label: "Serbia e Montenegro" },
  { value: "SC", label: "Seychelles", ita_label: "Seychelles" },
  { value: "SL", label: "Sierra Leone", ita_label: "Sierra Leone" },
  { value: "SG", label: "Singapore", ita_label: "Singapore" },
  { value: "SK", label: "Slovakia", ita_label: "Slovacchia" },
  { value: "SI", label: "Slovenia", ita_label: "Slovenia" },
  { value: "SB", label: "Solomon Islands", ita_label: "Isole Salomone" },
  { value: "SO", label: "Somalia", ita_label: "Somalia" },
  { value: "ZA", label: "South Africa", ita_label: "Sudafrica" },
  {
    value: "GS",
    label: "South Georgia and the South Sandwich Islands",
    ita_label: "Georgia del Sud e Isole Sandwich Meridionali",
  },
  { value: "KR", label: "South Korea", ita_label: "Corea del Sud" },
  { value: "ES", label: "Spain", ita_label: "Spagna" },
  { value: "LK", label: "Sri Lanka", ita_label: "Sri Lanka" },
  { value: "SD", label: "Sudan", ita_label: "Sudan" },
  { value: "SR", label: "Suriname", ita_label: "Suriname" },
  { value: "SJ", label: "Svalbard and Jan Mayen", ita_label: "Svalbard e Jan Mayen" },
  { value: "SZ", label: "Swaziland", ita_label: "Swaziland" },
  { value: "SE", label: "Sweden", ita_label: "Svezia" },
  { value: "CH", label: "Switzerland", ita_label: "Svizzera" },
  { value: "SY", label: "Syria", ita_label: "Siria" },
  { value: "ST", label: "São Tomé and Príncipe", ita_label: "São Tomé e Príncipe" },
  { value: "TW", label: "Taiwan", ita_label: "Taiwan" },
  { value: "TJ", label: "Tajikistan", ita_label: "Tagikistan" },
  { value: "TZ", label: "Tanzania", ita_label: "Tanzania" },
  { value: "TH", label: "Thailand", ita_label: "Thailandia" },
  { value: "TL", label: "Timor-Leste", ita_label: "Timor Est" },
  { value: "TG", label: "Togo", ita_label: "Togo" },
  { value: "TK", label: "Tokelau", ita_label: "Tokelau" },
  { value: "TO", label: "Tonga", ita_label: "Tonga" },
  { value: "TT", label: "Trinidad and Tobago", ita_label: "Trinidad e Tobago" },
  { value: "TN", label: "Tunisia", ita_label: "Tunisia" },
  { value: "TR", label: "Turkey", ita_label: "Turchia" },
  { value: "™", label: "Turkmenistan", ita_label: "Turkmenistan" },
  { value: "TC", label: "Turks and Caicos Islands", ita_label: "Isole Turks e Caicos" },
  { value: "TV", label: "Tuvalu", ita_label: "Tuvalu" },
  { value: "UM", label: "U.S. Minor Outlying Islands", ita_label: "Isole minori esterne degli Stati Uniti d'America" },
  { value: "VI", label: "U.S. Virgin Islands", ita_label: "Isole Vergini Americane" },
  { value: "UG", label: "Uganda", ita_label: "Uganda" },
  { value: "UA", label: "Ukraine", ita_label: "Ucraina" },
  {
    value: "SU",
    label: "Union of Soviet Socialist Republics",
    ita_label: "Unione delle Repubbliche Socialiste Sovietiche",
  },
  { value: "AE", label: "United Arab Emirates", ita_label: "Emirati Arabi Uniti" },
  { value: "GB", label: "United Kingdom", ita_label: "Regno Unito" },
  { value: "US", label: "United States", ita_label: "Stati Uniti" },
  { value: "UY", label: "Uruguay", ita_label: "Uruguay" },
  { value: "UZ", label: "Uzbekistan", ita_label: "Uzbekistan" },
  { value: "VU", label: "Vanuatu", ita_label: "Vanuatu" },
  { value: "VA", label: "Vatican City", ita_label: "Città del Vaticano" },
  { value: "VE", label: "Venezuela", ita_label: "Venezuela" },
  { value: "VN", label: "Vietnam", ita_label: "Vietnam" },
  { value: "WF", label: "Wallis and Futuna", ita_label: "Wallis e Futuna" },
  { value: "EH", label: "Western Sahara", ita_label: "Sahara Occidentale" },
  { value: "YE", label: "Yemen", ita_label: "Yemen" },
  { value: "ZM", label: "Zambia", ita_label: "Zambia" },
  { value: "ZW", label: "Zimbabwe", ita_label: "Zimbabwe" },
  { value: "AX", label: "Åland Islands", ita_label: "Isole Åland" },
];

export const euCountries = [
  "AT",
  "BE",
  "BG",
  "CY",
  "HR",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GB",
  "EL",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "CZ",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "HU",
];

export const province = [
  {
    value: "AG",
    label: "Agrigento",
  },
  {
    value: "AL",
    label: "Alessandria",
  },
  {
    value: "AN",
    label: "Ancona",
  },
  {
    value: "AO",
    label: "Aosta",
  },
  {
    value: "AR",
    label: "Arezzo",
  },
  {
    value: "AP",
    label: "Ascoli Piceno",
  },
  {
    value: "AT",
    label: "Asti",
  },
  {
    value: "AV",
    label: "Avellino",
  },
  {
    value: "BA",
    label: "Bari",
  },
  {
    value: "BT",
    label: "Barletta-Andria-Trani",
  },
  {
    value: "BL",
    label: "Belluno",
  },
  {
    value: "BN",
    label: "Benevento",
  },
  {
    value: "BG",
    label: "Bergamo",
  },
  {
    value: "BI",
    label: "Biella",
  },
  {
    value: "BO",
    label: "Bologna",
  },
  {
    value: "BZ",
    label: "Bolzano",
  },
  {
    value: "BS",
    label: "Brescia",
  },
  {
    value: "BR",
    label: "Brindisi",
  },
  {
    value: "CA",
    label: "Cagliari",
  },
  {
    value: "CL",
    label: "Caltanissetta",
  },
  {
    value: "CB",
    label: "Campobasso",
  },
  {
    value: "CI",
    label: "Carbonia-iglesias",
  },
  {
    value: "CE",
    label: "Caserta",
  },
  {
    value: "CT",
    label: "Catania",
  },
  {
    value: "CZ",
    label: "Catanzaro",
  },
  {
    value: "CH",
    label: "Chieti",
  },
  {
    value: "CO",
    label: "Como",
  },
  {
    value: "CS",
    label: "Cosenza",
  },
  {
    value: "CR",
    label: "Cremona",
  },
  {
    value: "KR",
    label: "Crotone",
  },
  {
    value: "CN",
    label: "Cuneo",
  },
  {
    value: "EN",
    label: "Enna",
  },
  {
    value: "FM",
    label: "Fermo",
  },
  {
    value: "FE",
    label: "Ferrara",
  },
  {
    value: "FI",
    label: "Firenze",
  },
  {
    value: "FG",
    label: "Foggia",
  },
  {
    value: "FC",
    label: "Forl&igrave;-Cesena",
  },
  {
    value: "FR",
    label: "Frosinone",
  },
  {
    value: "GE",
    label: "Genova",
  },
  {
    value: "GO",
    label: "Gorizia",
  },
  {
    value: "GR",
    label: "Grosseto",
  },
  {
    value: "IM",
    label: "Imperia",
  },
  {
    value: "IS",
    label: "Isernia",
  },
  {
    value: "SP",
    label: "La spezia",
  },
  {
    value: "AQ",
    label: "L'aquila",
  },
  {
    value: "LT",
    label: "Latina",
  },
  {
    value: "LE",
    label: "Lecce",
  },
  {
    value: "LC",
    label: "Lecco",
  },
  {
    value: "LI",
    label: "Livorno",
  },
  {
    value: "LO",
    label: "Lodi",
  },
  {
    value: "LU",
    label: "Lucca",
  },
  {
    value: "MC",
    label: "Macerata",
  },
  {
    value: "MN",
    label: "Mantova",
  },
  {
    value: "MS",
    label: "Massa-Carrara",
  },
  {
    value: "MT",
    label: "Matera",
  },
  {
    value: "VS",
    label: "Medio Campidano",
  },
  {
    value: "ME",
    label: "Messina",
  },
  {
    value: "MI",
    label: "Milano",
  },
  {
    value: "MO",
    label: "Modena",
  },
  {
    value: "MB",
    label: "Monza e della Brianza",
  },
  {
    value: "NA",
    label: "Napoli",
  },
  {
    value: "NO",
    label: "Novara",
  },
  {
    value: "NU",
    label: "Nuoro",
  },
  {
    value: "OG",
    label: "Ogliastra",
  },
  {
    value: "OT",
    label: "Olbia-Tempio",
  },
  {
    value: "OR",
    label: "Oristano",
  },
  {
    value: "PD",
    label: "Padova",
  },
  {
    value: "PA",
    label: "Palermo",
  },
  {
    value: "PR",
    label: "Parma",
  },
  {
    value: "PV",
    label: "Pavia",
  },
  {
    value: "PG",
    label: "Perugia",
  },
  {
    value: "PU",
    label: "Pesaro e Urbino",
  },
  {
    value: "PE",
    label: "Pescara",
  },
  {
    value: "PC",
    label: "Piacenza",
  },
  {
    value: "PI",
    label: "Pisa",
  },
  {
    value: "PT",
    label: "Pistoia",
  },
  {
    value: "PN",
    label: "Pordenone",
  },
  {
    value: "PZ",
    label: "Potenza",
  },
  {
    value: "PO",
    label: "Prato",
  },
  {
    value: "RG",
    label: "Ragusa",
  },
  {
    value: "RA",
    label: "Ravenna",
  },
  {
    value: "RC",
    label: "Reggio di Calabria",
  },
  {
    value: "RE",
    label: "Reggio nell'Emilia",
  },
  {
    value: "RI",
    label: "Rieti",
  },
  {
    value: "RN",
    label: "Rimini",
  },
  {
    value: "RM",
    label: "Roma",
  },
  {
    value: "RO",
    label: "Rovigo",
  },
  {
    value: "SA",
    label: "Salerno",
  },
  {
    value: "SS",
    label: "Sassari",
  },
  {
    value: "SV",
    label: "Savona",
  },
  {
    value: "SI",
    label: "Siena",
  },
  {
    value: "SR",
    label: "Siracusa",
  },
  {
    value: "SO",
    label: "Sondrio",
  },
  {
    value: "TA",
    label: "Taranto",
  },
  {
    value: "TE",
    label: "Teramo",
  },
  {
    value: "TR",
    label: "Terni",
  },
  {
    value: "TO",
    label: "Torino",
  },
  {
    value: "TP",
    label: "Trapani",
  },
  {
    value: "TN",
    label: "Trento",
  },
  {
    value: "TV",
    label: "Treviso",
  },
  {
    value: "TS",
    label: "Trieste",
  },
  {
    value: "UD",
    label: "Udine",
  },
  {
    value: "VA",
    label: "Varese",
  },
  {
    value: "VE",
    label: "Venezia",
  },
  {
    value: "VB",
    label: "Verbano-Cusio-Ossola",
  },
  {
    value: "VC",
    label: "Vercelli",
  },
  {
    value: "VR",
    label: "Verona",
  },
  {
    value: "VV",
    label: "Vibo valentia",
  },
  {
    value: "VI",
    label: "Vicenza",
  },
  {
    value: "VT",
    label: "Viterbo",
  },
];

export const signatureBytesLimit = 150 * 1024;

// export const DELIVERY_FREE_PLAN_VOLUME = 0;

export const deliveryPlans = {
  FREE: "free",
  PREPAID: "prepaid",
  MONTHLY: "monthly",
};

export const domainsPerDeliveryAccountsLimits = {
  free: 50,
  paid: 250,
};
